import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Cookies from 'js-cookie';

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ResponseError = /*#__PURE__*/function (_Error) {
  _inherits(ResponseError, _Error);

  var _super = _createSuper$1(ResponseError);

  function ResponseError(message, responseData, status) {
    var _this;

    _classCallCheck(this, ResponseError);

    _this = _super.call(this, message);
    _this.name = 'ResponseError';
    _this.responseData = responseData;
    _this.status = status;
    return _this;
  }

  _createClass(ResponseError, [{
    key: "getResponseData",
    value: function getResponseData() {
      return this.responseData;
    }
  }]);

  return ResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ValidationError = /*#__PURE__*/function (_ResponseError) {
  _inherits(ValidationError, _ResponseError);

  var _super = _createSuper(ValidationError);

  function ValidationError(message, responseData, status) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _super.call(this, message, responseData, status);
    _this.name = 'ValidationError';
    return _this;
  }

  _createClass(ValidationError, [{
    key: "getErrors",
    value: function getErrors() {
      return this.responseData;
    }
  }]);

  return ValidationError;
}(ResponseError);

var getResponseAndDataObject = function getResponseAndDataObject(response) {
  return response.json().then(function (data) {
    return {
      data: data,
      response: response
    };
  });
};

var throwResponseError = function throwResponseError(responseObject) {
  var response = responseObject.response,
      data = responseObject.data;

  if (response.status >= 200 && response.status < 300) {
    return data;
  }

  throw new ResponseError(response.statusText, data, response.status);
};
var throwValidationError = function throwValidationError(error) {
  if (error.name === 'ResponseError' && error.status === 422) {
    throw new ValidationError(error.message, error.responseData, error.status);
  }

  throw error;
};

var _excluded$2 = ["headers"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getJSON = function getJSON(url, opts) {
  var _ref = opts || {},
      headers = _ref.headers,
      options = _objectWithoutProperties(_ref, _excluded$2);

  return fetch(url, _objectSpread$2({
    method: 'GET',
    headers: _objectSpread$2({
      Accept: 'application/json'
    }, headers || null)
  }, options || null)).then(getResponseAndDataObject).then(throwResponseError);
};

var _excluded$1 = ["headers"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var postJSON = function postJSON(url, data, opts) {
  var _ref = opts || {},
      headers = _ref.headers,
      options = _objectWithoutProperties(_ref, _excluded$1);

  return fetch(url, _objectSpread$1({
    method: 'POST',
    headers: _objectSpread$1({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }, headers || null),
    body: JSON.stringify(data)
  }, options || null)).then(getResponseAndDataObject).then(throwResponseError).catch(throwValidationError);
};

var _excluded = ["headers", "fileParamName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  headers: null,
  fileParamName: 'file'
};

var uploadFile = function uploadFile(url, file) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _defaultOptions$opts = _objectSpread(_objectSpread({}, defaultOptions), opts),
      headers = _defaultOptions$opts.headers,
      fileParamName = _defaultOptions$opts.fileParamName,
      options = _objectWithoutProperties(_defaultOptions$opts, _excluded);

  var formData = new FormData();
  formData.append(fileParamName, file);
  return fetch(url, _objectSpread({
    method: 'POST',
    headers: _objectSpread({
      Accept: 'application/json'
    }, headers),
    body: formData
  }, options || null)).then(getResponseAndDataObject).then(throwResponseError).catch(throwValidationError);
};

var getXSRFToken = function getXSRFToken() {
  var cookies = Cookies.get();
  return cookies['XSRF-TOKEN'] || null;
};
var getCsrfToken = function getCsrfToken(name) {
  var metaName = name || 'csrf-token';

  if (typeof document === 'undefined') {
    return null;
  }

  var metas = [].slice.call(document.getElementsByTagName('meta'));
  return metas.reduce(function (val, meta) {
    return meta.getAttribute('name') === metaName ? meta.getAttribute('content') : val;
  }, null);
};
var getCSRFHeaders = function getCSRFHeaders(name) {
  var XSRF = getXSRFToken();

  if (XSRF !== null) {
    return {
      'X-XSRF-TOKEN': XSRF
    };
  }

  var CSRF = getCsrfToken(name);

  if (CSRF !== null) {
    return {
      'X-CSRF-TOKEN': CSRF
    };
  }

  return null;
};

export { ResponseError, ValidationError, getCSRFHeaders, getCsrfToken, getJSON, getResponseAndDataObject, getXSRFToken, postJSON, throwResponseError, throwValidationError, uploadFile };
